import React from 'react';

var Progress = function (_a) {
    var _b = _a.progress, progress = _b === void 0 ? 0 : _b;
    return (React.createElement("div", { className: 'progress' },
        React.createElement("div", { className: 'loading-page-line' },
            React.createElement("div", { className: 'loading-page-line-inside', style: progress || progress === 0 ? { transform: "translateX(".concat(progress, "%)") } : null }))));
};

export { Progress };
